/**
 * @fileoverview Main application store using Pinia
 * Replaces custom state management with Vue-native solution
 */

import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useAppStore = defineStore('app', () => {
  // State
  const globeActive = ref(false);
  const flowsVisible = ref(false);
  const experienceSectionActive = ref(false);
  const selectedManagerIndex = ref(null);
  const statsMode = ref(false);

  const layers = ref({
    managers: true,  // FIX: Set to true so manager labels/cards are visible by default
    flows: true,
    investors: true
  });

  const performance = ref({
    lcp: null,
    fid: null,
    cls: null,
    fcp: null,
    ttfb: null
  });

  const device = ref({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isTouch: false,
    width: 0,
    height: 0,
    dpr: 1,
    os: 'unknown',
    isLowEnd: false
  });

  const letsTalkActive = ref(false);

  // Getters
  const isGlobeOverlay = computed(() => globeActive.value);
  const activeFlows = computed(() => flowsVisible.value);
  const hasSelectedManager = computed(() => selectedManagerIndex.value !== null);

  // Actions
  function toggleGlobe() {
    globeActive.value = !globeActive.value;
  }

  function showGlobe() {
    globeActive.value = true;
  }

  function closeGlobe() {
    globeActive.value = false;
  }

  function toggleFlows() {
    flowsVisible.value = !flowsVisible.value;
  }

  function selectManager(index) {
    selectedManagerIndex.value = index;
  }

  function deselectManager() {
    selectedManagerIndex.value = null;
  }

  function toggleLayer(layerName) {
    if (layers.value[layerName] !== undefined) {
      layers.value[layerName] = !layers.value[layerName];
    }
  }

  function setPerformanceMetric(metric, value) {
    if (performance.value[metric] !== undefined) {
      performance.value[metric] = value;
    }
  }

  function updateDevice(deviceInfo) {
    device.value = { ...device.value, ...deviceInfo };
  }

  function toggleStatsMode() {
    statsMode.value = !statsMode.value;
  }

  function setExperienceSectionActive(isActive) {
    experienceSectionActive.value = isActive;
  }

  function setLetsTalkActive(isActive) {
    letsTalkActive.value = isActive;
  }

  function reset() {
    globeActive.value = false;
    flowsVisible.value = false;
    selectedManagerIndex.value = null;
    statsMode.value = false;
    letsTalkActive.value = false;
  }

  return {
    // State
    globeActive,
    flowsVisible,
    experienceSectionActive,
    letsTalkActive,
    selectedManagerIndex,
    statsMode,
    layers,
    performance,
    device,

    // Getters
    isGlobeOverlay,
    activeFlows,
    hasSelectedManager,

    // Actions
    toggleGlobe,
    showGlobe,
    closeGlobe,
    toggleFlows,
    selectManager,
    deselectManager,
    toggleLayer,
    setPerformanceMetric,
    updateDevice,
    toggleStatsMode,
    setExperienceSectionActive,
    setLetsTalkActive,
    reset
  };
});
